import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Chip,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { UserContext } from "UserContext";
import auth from "auth";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 277,
  },
  button: {
    color: theme.palette.primary.dark,
    textTransform: "none",
  },
  icon: {
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 16,
    height: 34,
    width: 34,
    marginLeft: 0,
    padding: 6,
  },
  chip: {
    backgroundColor: theme.palette.primary.light,
    height: 34,
    color: theme.palette.primary.main,
  },
  menu: {
    marginTop: 1,
  },
}));

const UserChip = ({ ...props }) => {
  const classes = useStyles();
  const { user, logOut, token } = useContext(UserContext);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const openMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchorEl(null);
  };

  return (
    <Box {...props}>
      <Grid
        className={classes.root}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item />
        <Grid item>
          <Chip
            icon={<PersonIcon className={classes.icon} />}
            label={user ? user.username : ""}
            className={classes.chip}
            onClick={openMenu}
          />
          <Menu
            id="profile-menu"
            getContentAnchorEl={null}
            className={classes.menu}
            anchorEl={menuAnchorEl}
            keepMounted
            open={Boolean(menuAnchorEl)}
            onClose={closeMenu}
            elevation={1}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <MenuItem onClick={() => auth.changePassword(token)}>
              <ListItemIcon>
                <LockOpenIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Change Password</ListItemText>
            </MenuItem>
            <MenuItem onClick={logOut}>
              <ListItemIcon>
                <ExitToAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserChip;
